<ion-row class="row-m">
    <ion-col class="">
      <div class="backorforth">
        <div id="bf_aar" *ngIf="_chartTypes.Aar.active">
          {{ minDate.getFullYear() }} - {{ maxDate.getFullYear()
          }}
        </div>
        <div id="bf_mnd" *ngIf="_chartTypes.Maaned.active">
          Hittil i {{ currentYear }}
        </div>

        <div id="bf_dag" *ngIf="_chartTypes.Dag.active">
          <table width="100%">
            <tr>
              <td width="10%" (click)="moveBack('month')">
                <ion-icon
                  [class]="
                      dayBack
                        ? 'enabledicon hydrated pointer'
                        : 'disabledicon'
                    "
                  size="medium"
                  name="chevron-back-outline"
                ></ion-icon>
              </td>
              <td width="80%">
                <span (click)="showHideCal('month')" class="pointer">
                  {{ selectedDateDay | date: 'MMMM yyyy':'':'nb' |
                  titlecase }} &nbsp;<ion-icon name="calendar"></ion-icon>
                </span>
              </td>
              <td width="10%" (click)="moveForth('month')">
                <ion-icon
                  [class]="
                      dayForward
                        ? 'enabledicon hydrated pointer'
                        : 'disabledicon hydrated'
                    "
                  name="chevron-forward-outline"
                ></ion-icon>
              </td>
            </tr>
          </table>
        </div>
        <div id="bf_time" *ngIf="_chartTypes.Time.active">
          <table width="100%">
            <tr>
              <td width="10%" (click)="moveBack('day')">
                <ion-icon
                  [class]="
                      hourBack
                        ? 'enabledicon hydrated pointer'
                        : 'disabledicon hydrated'
                    "
                  size="medium"
                  name="chevron-back-outline"
                ></ion-icon>
              </td>
              <td width="80%">
                <span (click)="showHideCal('day')" class="pointer">
                  {{ selectedDateHour | date: 'd. MMMM yyyy':'':'nb'
                  }} &nbsp;<ion-icon name="calendar"></ion-icon>
                </span>
              </td>
              <td width="10%" (click)="moveForth('day')">
                <ion-icon
                  [class]="
                      hourForward
                        ? 'enabledicon hydrated pointer'
                        : 'disabledicon hydrated'
                    "
                  name="chevron-forward-outline"
                ></ion-icon>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div
        class="datepicker-popup"
        [style.display]="showMonthCal ? 'inline' : 'none'"
      >
        <div
          style="
            margin-left: auto;
            margin-right: auto;
            display: inline-block;
            text-align: match-parent;
            border: 0px;
          "
        >
          <div class="datepicker-here" id="airDay"></div>
        </div>
      </div>
      <div
        class="datepicker-popup"
        [style.display]="showDayCal ? 'inline' : 'none'"
      >
        <div
          style="
            margin-left: auto;
            margin-right: auto;
            display: inline-block;
            text-align: match-parent;
            border: 0px;
          "
        >
          <div class="datepicker-here" id="airHour"></div>
        </div>
      </div>
    </ion-col>
</ion-row>